import React, { Fragment, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useNewSubjectStore } from "../../../../stores/newSubjectStore";
import BrainLoadingWrapper from "../../../../../../core/components/molecules/BrainLoading";
import { useNewExerciseHook } from "../../../../hooks/useNewExercise";
import { useExerciseStore } from "../../../../stores/exercisesStore";
import InfiniteScroll from "react-infinite-scroll-component";
import ContentLoading from "../../../../../../core/components/atoms/ContentLoading";
import ExerciseCard from "../../exerciseCard";
import { useDisciplinesAuxStore } from "../../../../stores/auxStore";
import { IResponseFavorite } from "../../../../hooks/useContentFavorite";
import getSubjectByFilter from '../../../../../../core/commom/getSubjectByFilter';
import { useFreemiumLock } from "../../../../../../core/components/organism/FreemiumLockModal/useFreemiumLock";

interface IContentModalExercise {
  onClose: () => void;
}

const ContentModalExercise: React.FC<IContentModalExercise> = ({ onClose }) => {
  const { module, discipline, slug } = useParams();
  const { mutate, isPending } = useNewExerciseHook();
  const { selectedSubjects } = useNewSubjectStore();
  const {
    exercises,
    totalExercises,
    favorite,
    unanswered,
    rightAnswer,
    wrongAnswer,
    difficulty,
    trialOptions,
    questionOptions,
    isEnem
  } = useExerciseStore();
  const { setPlaylistResultNumber } = useDisciplinesAuxStore();
  const { isLocked, openLock } = useFreemiumLock();

  const [page, setPage] = useState<number>(1);

  useEffect(() => {
    if(module) {
      setPage(1);
      mutate({ module, operation: 'initial', page: 1 });
    }
  }, [module, selectedSubjects]);

  useEffect(() => {
    if (totalExercises && exercises.length < totalExercises && page > 1 && module) {
      mutate({ module, operation: 'pagination', page });
    }
  }, [page]);

  useEffect(() => {
    if(module) {
      setPage(1);
      mutate({ module, operation:'filter', page: 1 });
    }
  }, [
    favorite,
    unanswered,
    rightAnswer,
    wrongAnswer,
    difficulty,
    trialOptions,
    isEnem,
    questionOptions,
  ])

  useEffect(() => {
    setPlaylistResultNumber(exercises.length);
  }, [exercises])

  const callbackFav = (data: IResponseFavorite) => {
    if(data.ok && module) {
      mutate({ module, operation: 'initial', page: 1 });
    }
  }

  if(isPending) {
    return <BrainLoadingWrapper />
  }


  return (
    <Fragment>
      <InfiniteScroll
        dataLength={exercises.length}
        next={() => setPage(page + 1)}
        hasMore={totalExercises ? exercises.length < totalExercises : false}
        loader={<ContentLoading type='list' />}
        className='flex flex-col gap-lg bg-color-transparent'
        style={{ overflow: 'visible' }}
      >
        {exercises &&
          exercises.map((it, i) => (
            <ExerciseCard
              key={i}
              exercise={it}
              discipline={discipline ?? ''}
              module={module ?? ''}
              subjectSlug={it.subjects[0].slug}
              subject={getSubjectByFilter(it.subjects, selectedSubjects)}
              slug={slug ?? ''}
              done={it.seen}
              favorite={it.favorite}
              onClose={onClose}
              callback={(data) => callbackFav(data)}
              locked={isLocked(it)}
              onLockedClick={openLock}
            />
          ))}
      </InfiniteScroll>
    </Fragment>
  )
}

export default ContentModalExercise;
